import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import i18next from "i18next";
// import Backend from 'i18next-http-backend';
// import { DateTime } from 'luxon';
import resourcesToBackend from 'i18next-resources-to-backend';
import Backend from 'i18next-chained-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';
function genRandonNumber(length: number) {
    const chars = '0123456789';
    const charLength = chars.length;
    let result = '';
    for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * charLength));
    }
    return result;
}

const HASH = genRandonNumber(10);

i18n
    // loads translations from your server
    .use(Backend)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        // debug: true,
        fallbackLng: 'hu',
        ns: [
            'translation',
            'countries',
            'errors',
            'product',
            'collection',
            'quotations',
            'invoices',
            'liveOrders',
            'admin',
            'cart',
        ],
        backend: {
            backends: [
                LocalStorageBackend, // primary ressources (cache = window.localStorage)
                resourcesToBackend((language, namespace, callback) => {
                    import(`/public/locales/${language}/${namespace}.json`)
                        .then((resources) => {
                            callback(null, resources);
                        })
                        .catch((error) => {
                            callback(error, null);
                        });
                }), // fallback ressources (json)
            ],
            backendOptions: [
                {
                    expirationTime: 24 * 60 * 60 * 1000 * 7, // 7 days
                    defaultVersion: 'v' + HASH, // generate a new version every build to refresh
                },
            ],
        },
        interpolation: {
            escapeValue: false,
        },
    });

// new usage
// i18n.services.formatter.add('DATE_HUGE', (value, lng, options) => {
//     return DateTime.fromJSDate(value).setLocale(lng).toLocaleString(DateTime.DATE_HUGE)
// });

export default i18n;

// i18next.use(initReactI18next).init({
//     debug: false,
//     lng: 'hu',
//     resources: {
//         en: {
//             translation: {
//                 welcome: 'welcome to react with i18n',
//             },
//         },
//         hu: {
//             translation: {
//                 welcome: 'üdvözöllek a react-ben + i18n',
//             },
//         },
//     },
//     fallbackLng: 'en',
//     interpolation: {
//         escapeValue: false,
//     },
// });
